export default "/react/posevyIcon-d8a1208e.svg";